module.exports = __webpack_public_path__ + "static/img/17.ed12d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/17.jpg
// module id = YE5A
// module chunks = 1